import script from "./LogDialog.vue?vue&type=script&setup=true&lang=ts&name=departmentDialog"
export * from "./LogDialog.vue?vue&type=script&setup=true&lang=ts&name=departmentDialog"

const __exports__ = script;

export default __exports__